import { useEffect } from "react";

export default function useScrollRestoration(key = "scroll-pos") {
  useEffect(() => {
    // Restore scroll position if exists
    const saved = sessionStorage.getItem(key);
    // instant jump — smooth scroll-behavior would animate from the top and fight the snap
    if (saved) window.scrollTo({ top: parseInt(saved, 10), behavior: "instant" });

    // The scroll event fires per frame; writing sessionStorage inside it is a
    // synchronous store hit on every one of those frames and shows up as
    // stutter. Coalesce to one write per animation frame instead, and keep the
    // listener passive so the browser never waits on us to scroll.
    let frame = null;
    const handleScroll = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        sessionStorage.setItem(key, window.scrollY);
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (frame !== null) cancelAnimationFrame(frame);
    };
  }, [key]);
}
